"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCheckActiveWithdrawalParam = void 0;
const react_redux_1 = require("react-redux");
const selectors_1 = require("../containers/BalanceProvider/selectors");
const balance_1 = require("../utils/balance");
const useCheckActiveWithdrawalParam = (parameterType) => {
    const currentWithdrawal = (0, react_redux_1.useSelector)(selectors_1.selectCurrentWithdrawalMethod);
    return (currentWithdrawal &&
        !!(0, balance_1.findTransactionParam)(currentWithdrawal === null || currentWithdrawal === void 0 ? void 0 : currentWithdrawal.withdraw_params, parameterType));
};
exports.useCheckActiveWithdrawalParam = useCheckActiveWithdrawalParam;
//# sourceMappingURL=useCheckActiveWithdrawalParam.js.map